module.exports = "<igo-catalog-list\r\n  igoCatalogListBinding\r\n  (select)=\"handleFeatureSelect()\">\r\n</igo-catalog-list>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/tool/tools/catalog-tool/catalog-tool.component.html
// module id = 1119
// module chunks = 0